import { PageSectionType } from './../enums/page-section-type';
import { IMutations } from '../interfaces/store.interfaces';
import state from './state';
import IStep from '@/interfaces/step.interface';
import { JourneyMenuTab } from '@/enums/journey-menu-tab';
import { CurrentEligibilityScholarshipDTO } from '@studyportals/eligibility-model';

const mutations: IMutations = {
	setActivePageSection: (section: PageSectionType) => {
		state.activePageSection = section;
	},
	setGender: (gender) => {
		state.gender = gender;
	},
	setName: (name) => {
		state.name = name;
	},
	setEmail: (email) => {
		state.email = email;
	},
	setCountriesOfInterest: (countries) => {
		state.countriesOfInterest = countries;
	},
	setAttendance: (attendance) => {
		state.attendance = attendance;
	},
	setDisciplinesOfInterest: (disciplines) => {
		state.disciplinesOfInterest = disciplines;
	},
	setResidenceCountry: (country) => {
		state.residenceCountry = country;
	},
	setNationalityCountry: (country) => {
		state.nationalityCountry = country;
	},
	setStartDate: (date) => {
		state.startDate = date;
	},
	setProfileCompleteness: (completeness) => {
		state.profileCompleteness = completeness;
	},
	setIsInitialStudentDataLoaded: (loaded: boolean) => {
		state.isInitialStudentDataLoaded = loaded;
	},
	setContentSwitcher: (section, contentSwitcher) => {
		state.contentSwitcher[section] = contentSwitcher;
	},
	setLoggedInState: (isLoggedIn) => {
		state.isLoggedIn = isLoggedIn;
	},
	setEmailingFavourites: (emailingFavourites: boolean) => {
		state.emailingFavourites = emailingFavourites;
	},
	setEmailingOther: (emailingOther: boolean) => {
		state.emailingOther = emailingOther;
	},
	setEmailingScholarships: (emailingScholarships: boolean) => {
		state.emailingScholarships = emailingScholarships;
	},
	setEmailingUpdates: (emailingUpdates: boolean) => {
		state.emailingUpdates = emailingUpdates;
	},
	setCurrentJourneyMenuTab: (view: JourneyMenuTab) => {
		state.currentJourneyMenuTab = view;
	},
	setJourneySteps: (steps) => {
		state.journeySteps = steps;
	},
	setIsMenuActive: (isActive) => {
		state.isMenuActive = isActive;
	},
	setWishlistCount: (count) => {
		state.wishlistStudyCount = count || 0;
	},
	setJourneyState: (journeyState) => {
		state.journeyState = journeyState;
	},
	setEvaluateView: (evaluateView: boolean) => {
		state.evaluateView = evaluateView;
	},
	setNumberOfFavouritesInIsApplyingState: (numberOfFavouritesInIsApplyingState: number) => {
		state.numberOfFavouritesInIsApplyingState = numberOfFavouritesInIsApplyingState;
	},
	setNumberOfFavouritesHasApplied: (numberOfFavouritesHasApplied: number) => {
		state.numberOfFavouritesHasAppliedState = numberOfFavouritesHasApplied;
	},
	setCreatingApplicationChecklistView: (creatingApplicationChecklistView: boolean) => {
		state.creatingApplicationChecklistView = creatingApplicationChecklistView;
	},
	setCurrentJourneyStep: (step: IStep) => {
		state.currentStep = step;
	},
	setScholarshipEligibility: (scholarshipEligibility: CurrentEligibilityScholarshipDTO) => {
		state.scholarshipEligibility = scholarshipEligibility;
	},
	setCurrentRoute: (route) => {
		state.currentRoute = route;
	},
	setScholarshipEligibilityItemsFlags: (eligibilityFlags: { [key: string]: number | boolean }) => {
		state.scholarshipEligibilityFlags = eligibilityFlags;
	},
};

export default mutations;
